<template>
  <section>
    <preview-job-comments
      :comments="commentHighlights"
      :is-show="isShowComment"
      class="pega-comment-bar-inner"
      v-on="$listeners"
    />
    <h5>
      <span data-test="title">{{ title }}</span>
    </h5>
    <p
      :id="id"
      class="location-area pega-pre-wrap"
      :class="[{'mb0': showToggleButton }, { 'omitted': !isOpenPlaces }]"
      data-test="place-text"
      v-html="placeText"
    />
    <a
      v-if="showToggleButton"
      href="javascript:void(0)"
      class="pull-right"
      data-test="toggle-button"
      @click.stop="togglePlaceText"
      @select.stop
    ><p
      class="pt5"
      data-test="toggle-text"
    >{{ togglePlacesText }}</p></a>
  </section>
</template>

<style scoped lang="scss">
@use "@/styles/preview/pc/base" as *;
</style>

<script>
import PreviewJobComments from '@/components/molecules/PreviewJobComments'
import jobPreviewCommon from '@/lib/jobPreviewCommon'
import jobPreviewVisibilityCommon from '@/lib/jobPreviewVisibilityCommon'
export default {
  components: {
    PreviewJobComments
  },
  mixins: [jobPreviewCommon, jobPreviewVisibilityCommon],
  props: {
    id: {
      type: String,
      required: true
    },
    places: {
      type: Array,
      default: () => []
    },
    title: {
      type: String,
      default: ''
    },
    commentHighlights: {
      type: Array,
      default: () => []
    },
    isShowComment: {
      type: Boolean,
      required: true
    }
  },
  data () {
    return {
      isOpenPlaces: true,
      placeTextHeight: 0
    }
  },
  computed: {
    showToggleButton () {
      return this.placeTextHeight > 48
    },
    hasHighlight () {
      return this.commentHighlights.some(i => i.highlight)
    }
  },
  mounted () {
    this.commentHighlights.forEach((commentHighlight) => {
      this.setHighlight(commentHighlight)
    })
    this.$set(this, 'placeTextHeight', document.getElementById(this.id).clientHeight)
    this.isOpenPlaces = !this.showToggleButton || this.hasHighlight
  },
  methods: {
    togglePlaceText () {
      // ハイライトがない場合のみ閉可能（省略エリアにハイライトされるとUIおかしくなるので）
      // ハイライトがあっても開くことは可能とする
      if (!this.isOpenPlaces || !this.hasHighlight) {
        this.isOpenPlaces = !this.isOpenPlaces
        return
      }
      this.$toasted.global.error({ message: 'ハイライトがあるため、エリアを閉じることはできません。' })
    }
  }
}
</script>
